<template>
  <div class="modal fade tax-modal margin-top-80" id="tax-modal" aria-hidden="true" aria-labelledby="exampleGrid" role="dialog">
    <div class="modal-dialog modal-simple modal-center modal-medium">
      <div class="modal-content">
        <form autocomplete="off" @submit.prevent="downloadCSV(taxesData)">
          <div class="modal-header">
            <div class="container">
              <div class="row header">
                <div class="col-8">
                  <h4 class="modal-title">{{ $t("calendar.index.city_taxes") }}</h4>
                </div>
                <div class="col-4">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeCityTaxesModal('#tax-modal')">
                    <span aria-hidden="true" class="close-btn">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group form-material">
                  <multiselect
                    @input="selectRental"
                    v-model="value"
                    :options="options"
                    :multiple="true"
                    :close-on-select="false"
                    group-values="libs"
                    group-label="language"
                    :group-select="true"
                    track-by="name"
                    label="name"
                    :searchable="false"
                    :selectLabel="$t('selectLabel')"
                    :selectGroupLabel="$t('selectGroupLabel')"
                    :selectedLabel="$t('selectedLabel')"
                    :deselectLabel="$t('deselectLabel')"
                    :deselectGroupLabel="$t('deselectGroupLabel')"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group form-material">
                  <label class="control-label" for="tax-month">{{ $t("input.month") }}</label>
                  <select id="tax-month" class="form-control" v-model="taxesData.month">
                    <option v-for="(month, index) in $t('months')" :value="index + 1 < 10 ? '0' + (index + 1) : index + 1">{{ $t('months')[index] }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group form-material">
                  <label for="tax-year" class="control-label">{{ $t("input.year") }}</label>
                  <select id="tax-year" class="form-control" v-model="taxesData.year">
                    <option v-for="year in taxYears" :value="year">{{ year }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center">
            <button type="button" class="btn  waves-effect waves-classic btn-cancel" id="tax-modal-close" @click.prevent="closeCityTaxesModal('#tax-modal')"
                    data-dismiss="modal">{{ $t("button.cancel") }}
            </button>
            <button type="submit" :class="'btn btn-primary waves-effect waves-classic btn-save'">{{ $t("button.download_csv") }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
    import mixin from '../../mixins/mixin';
    import moment from 'moment';
    import calendarService from '../../services/calendar';
    import Multiselect from 'vue-multiselect';


    export default {
      name: 'CityTaxesModal',
      props: [
        'rentals',
        'groups',
      ],
      mixins: [mixin],
      components: { Multiselect },
      data() {
        return {
          taxesData: {
            rental: {},
          },
          taxYears: [],
          value: [],
          options: [

          ],
        };
      },
      watch: {
        groups(newValue) {
          if (newValue.length) {
            this.generateGroups();
          }
        },
        getAccount(newValue, oldValue) {
          if (oldValue !== newValue) {
            this.generateGroups();
          }
        },
      },
      mounted() {
        this.fetchTaxYears();
      },
      methods: {
        setModalToDefaults() {
          this.taxesData = {
            month: moment().format('MM'),
            rental: this.rentals.length > 0 ? this.rentals[0] : '',
            rental_id: this.rentals.length > 0 ? this.rentals[0].id : '',
            year: new Date().getFullYear(),
          };
          this.value = [];
        },
        openCityTaxesModal() {
          if (this.rentals && this.rentals.length > 0) {
            this.setModalToDefaults();
            this.openModal('#tax-modal');
          } else {
            toastr.error(this.$t('rentals.index.no_result'));
          }
        },
        changeCityTaxesType(taxData) {
          calendarService.changeCityTaxesType(taxData, this);
        },

        async downloadCSV() {
          const rentalIds = [];
          this.value.map(val => rentalIds.push(val.id));
          this.taxesData.rental_ids = rentalIds;
          await calendarService.generateTaxCsv({ ...this.taxesData }, this);
          this.setModalToDefaults();
        },

        selectRental(selectedRentals) {
          this.value = selectedRentals;
        },

        fetchTaxYears() {
          const currentYear = new Date().getFullYear();
          const startYear = 2015;
          for (let i = startYear; i <= currentYear; i++) {
            this.taxYears.push(i);
          }
        },

        generateGroups() {
          this.options = [];
          this.groups.forEach((group) => {
            const option = {
              language: '',
              libs: [],
            };
            option.language = group.name === 'others' ? this.$t('groups.others') : group.name;
            group.rentals.forEach((item) => {
              option.libs.push({ name: item.name, id: item.id });
            });
            this.options.push(option);
          });
        },
        closeCityTaxesModal(modalName) {
          this.setModalToDefaults();
          this.value = [];
          this.closeModal(modalName);
        },
      },
      computed: {
        account() {
          return this.$store.state.account;
        },
        getAccount() {
          return this.$store.getters.account.lang;
        },
      },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// CityTaxesModal.vue?4b5b839a